import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6w2wcf7tpu: FaireBrandEntity = {
  token: "b_6w2wcf7tpu",
  type: "brand",
  name: "Mr. YuYu's Chililicious Candy",
  avatarUrl:
    "https://cdn.faire.com/fastly/e66ab442f76adc57179759c2b2ff0367a353247268d87d0fd13acf31f2843edd.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a7e864b78850291bf4de49e47911fa6a45464cdda68125f5a5793c4dcd0a83dd.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e66ab442f76adc57179759c2b2ff0367a353247268d87d0fd13acf31f2843edd.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a7e864b78850291bf4de49e47911fa6a45464cdda68125f5a5793c4dcd0a83dd.png",
  location: "El Cajon , CA, USA",
  minimumOrderDollars: 208,
  rating: 4.2,
  reviewCount: 19,
  isInsider: true,
  description:
    "Born from the heart of a small family business, our company began with a passion for sharing the vibrant, sweet, and spicy flavors of authentic Mexican Candy. We wanted to bring the joy and tradition of Mexico’s beloved treats to everyone, infusing each product with the warmth and love that comes from generations of family recipes.\n\nAs we grew, so did our curiosity for bold, unique flavors. We expanded into pickle kits, freeze-dried Candy, and our personal favorite—mouthwatering brisket jerky, smoked to perfection. Every product we craft tells a story of family, tradition, and a love for quality ingredients.\n\nFrom our family to yours, we're dedicated to bringing a taste of home into every bite—whether it's the nostalgia of Mexican candy or the exciting adventure of trying something new. We hope our products become a part of your family's favorite moments, just as they've been part of ours.\n\nWe handpick top quality gummies, mouthwatering flavor combos, and tasty textures to create a trip with your tongue!\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:59.011Z",
    importedBy: "entity-db-cli",
  },
};
